import { ConnectedPlumaProvider } from '@/components/connected-pluma-provider';
import Root from '@/layouts/root';
import ErrorPage from '@/pages/error.page';
import NotFoundPage from '@/pages/not-found.page';
import { isPageNotFoundError } from '@/services/router/page-error';
import { sentryCaptureException } from '@/utils/sentry';
import { createRootRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ThemeContextProvider } from '@/context/theme';

type RootErrorComponentProps = {
  error: unknown;
};

function RootErrorComponent({ error }: RootErrorComponentProps) {
  useEffect(() => {
    if (isPageNotFoundError(error)) {
      return;
    }

    sentryCaptureException(error);
  }, [error]);

  return (
    <ThemeContextProvider>
      <ConnectedPlumaProvider>
        {isPageNotFoundError(error) ? <NotFoundPage /> : <ErrorPage error={error} />}
      </ConnectedPlumaProvider>
    </ThemeContextProvider>
  );
}

export const Route = createRootRoute({
  component: Root,
  errorComponent: RootErrorComponent,
  notFoundComponent: NotFoundPage,
});
